import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { AgentMetricsResponse, LoadAgentMetricsPayload } from '../types'

interface State {
  data?: AgentMetricsResponse
  loading: boolean
  error: string
  requestKey: string
}

export const initialState: State = {
  loading: false,
  error: '',
  requestKey: ''
}
export const filtersKey = ({ period, year }: LoadAgentMetricsPayload) => `${period}:${year}`

const slice = createSlice({
  name: 'agentMetrics',
  initialState,
  reducers: {
    loadAgentMetrics: (state, action: PayloadAction<LoadAgentMetricsPayload>) => {
      state.loading = true
      state.error = ''
      state.requestKey = filtersKey(action.payload)
    },
    agentMetricsLoaded: (state, action: PayloadAction<{ requestKey: string; data: AgentMetricsResponse }>) => {
      if (state.requestKey !== action.payload.requestKey) return
      state.loading = false
      state.data = action.payload.data
    },
    agentMetricsFailed: (state, action: PayloadAction<{ requestKey: string; message: string }>) => {
      if (state.requestKey !== action.payload.requestKey) return
      state.loading = false
      state.error = action.payload.message
    },
    clearAgentMetrics: () => initialState
  }
})

export const selectAgentMetrics = createDraftSafeSelector([(state: GlobalState) => state.agentMetrics], state => state)
export const { loadAgentMetrics, agentMetricsLoaded, agentMetricsFailed, clearAgentMetrics } = slice.actions
export default slice.reducer
